import { SetOptional } from "type-fest";

export enum RouteTypes {
  Content = "Content",
  Alias = "Alias",
  Absolute = "Absolute",
  Default = "Default",
}

export enum Method {
  Create = "POST",
  Edit = "PUT",
}

export interface Route {
  id: number;
  routeType?: RouteTypes;
  fromPath: string;
  localeCode?: string;
  contentTypeConstraint?: string;
  toPath: string;
  hasSlug: boolean;
  method: Method;
  isContentPathRedirect?: boolean;
}

export type UpsertRoute = SetOptional<Route, "id" | "hasSlug">;
